module.exports = __webpack_public_path__ + "static/media/windows.ff02f514.svg";